/**
 * Director detail hero image slider (up to 10 gallery images).
 */
export class DirectorHeroSwiper {
  init(): void {
    const root = document.querySelector<HTMLElement>("[data-dir-hero-swiper]");
    if (!root || typeof (window as Window & { Swiper?: unknown }).Swiper === "undefined") {
      return;
    }

    const slides = root.querySelectorAll(".swiper-slide");
    if (slides.length <= 1) {
      return;
    }

    const SwiperClass = (
      window as Window & { Swiper: new (el: Element, o: object) => unknown }
    ).Swiper;

    const prevEl = root.querySelector<HTMLElement>(".dir-detail__hero-nav--prev");
    const nextEl = root.querySelector<HTMLElement>(".dir-detail__hero-nav--next");

    new SwiperClass(root, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: slides.length > 1,
      speed: 450,
      navigation:
        prevEl && nextEl
          ? { prevEl, nextEl }
          : undefined,
    });
  }
}
